import { CommonModule } from '@angular/common';
import { Component, computed, input, model } from '@angular/core';
import { IonRange } from '@ionic/angular/standalone';

export interface CrtSliderSelecteurOption {
  libelle: string;
  value: number;
}

type CrtSliderSelecteurInputOption = string | CrtSliderSelecteurOption;

/**
 * Slider
 */
@Component({
  selector: 'crt-slider-selecteur',
  templateUrl: 'slider-selecteur.component.html',
  styleUrls: ['slider-selecteur.component.scss'],
  standalone: true,
  imports: [IonRange, CommonModule],
})
export class CrtSliderSelecteurComponent {
  /**
   * Options
   * @param {CrtSliderSelecteurInputOption[]} options
   */
  public options = input<CrtSliderSelecteurInputOption[]>([]);
  /**
   * Valeur
   */
  public value = model(0);

  /**
   * Slideur grisé ou non
   */
  public disabled = input(false);
  /**
   * Paddings
   */
  public lateralPaddings = computed(() => 100 / (this.sliderOptions().length * 2));

  public sliderOptions = computed<CrtSliderSelecteurOption[]>(() =>
    this.options().map((option, index) => (typeof option === 'string' ? { libelle: option, value: index } : option))
  );

  /**
   * Appelée lorsqu'on clique sur un label du slideur
   */
  clickTextSlider(value: number) {
    if (!this.disabled()) {
      this.value.set(value);
    }
  }

  onValueChange(value: number | { lower: number; upper: number }) {
    this.value.set(Number(typeof value === 'number' ? value : value.lower));
  }
}
